import React from 'react';
import './LegalPages.css';

function ContactPage() {
  return (
    <div className="legal-page">
      <div className="legal-hero">
        <h1>Contact Us</h1>
        <p className="last-updated">We'd love to hear from you</p>
      </div>

      <div className="legal-content">
        <section className="legal-section">
          <h2>Get in Touch</h2>
          <p>Have questions, feedback, or need assistance? Reach out to us through any of the following channels:</p>
        </section>

        <section className="legal-section">
          <h2>Contact Information</h2>
          <div className="contact-grid">
            <div className="contact-item">
              <div className="contact-icon">📧</div>
              <h3>Email</h3>
              <p><strong>General Inquiries:</strong> info@discovercookislands.com</p>
              <p><strong>Business Listings:</strong> business@discovercookislands.com</p>
              <p><strong>Advertising:</strong> ads@discovercookislands.com</p>
              <p><strong>Technical Support:</strong> support@discovercookislands.com</p>
            </div>

            <div className="contact-item">
              <div className="contact-icon">📞</div>
              <h3>Phone</h3>
              <p><strong>Main Office:</strong> +682 20 123</p>
              <p><strong>Business Support:</strong> +682 20 456</p>
              <p className="note">Available Monday - Friday, 9:00 AM - 5:00 PM (Cook Islands Time)</p>
            </div>

            <div className="contact-item">
              <div className="contact-icon">📍</div>
              <h3>Address</h3>
              <p><strong>Discover Cook Islands</strong></p>
              <p>Rarotonga, Cook Islands</p>
            </div>

            <div className="contact-item">
              <div className="contact-icon">🌐</div>
              <h3>Social Media</h3>
              <p>Follow us for updates and news</p>
              <p><strong>Facebook:</strong> @DiscoverCookIslands</p>
              <p><strong>Instagram:</strong> @DiscoverCookIslands</p>
              <p><strong>Twitter:</strong> @DiscoverCookIslands</p>
            </div>
          </div>
        </section>

        <section className="legal-section">
          <h2>Business Listing Inquiries</h2>
          <p>Are you a business owner looking to be featured on Discover Cook Islands? We offer various listing options to help you reach more customers:</p>
          <ul>
            <li><strong>Free Basic Listings:</strong> Get your business on our platform at no cost</li>
            <li><strong>Premium Listings:</strong> Enhanced visibility with featured placement</li>
            <li><strong>Advertisement Campaigns:</strong> Targeted ads to reach your ideal customers</li>
          </ul>
          <p>Contact our business team at <strong>business@discovercookislands.com</strong> to learn more.</p>
        </section>

        <section className="legal-section">
          <h2>Technical Support</h2>
          <p>Experiencing technical issues with our website or mobile app? Our support team is here to help:</p>
          <ul>
            <li>Email: <strong>support@discovercookislands.com</strong></li>
            <li>Please include detailed information about the issue, including screenshots if possible</li>
            <li>We typically respond within 1-2 business days</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Feedback and Suggestions</h2>
          <p>Your feedback helps us improve Discover Cook Islands. We welcome your suggestions, comments, and ideas for making our platform better serve the Cook Islands community.</p>
          <p>Send your feedback to: <strong>feedback@discovercookislands.com</strong></p>
        </section>

        <section className="legal-section">
          <h2>Report an Issue</h2>
          <p>If you notice incorrect business information, inappropriate content, or any concerns about our platform, please let us know:</p>
          <ul>
            <li><strong>Incorrect Information:</strong> business@discovercookislands.com</li>
            <li><strong>Inappropriate Content:</strong> report@discovercookislands.com</li>
            <li><strong>Privacy Concerns:</strong> privacy@discovercookislands.com</li>
          </ul>
        </section>

        <section className="legal-section disclaimer">
          <h2>Response Time Disclaimer</h2>
          <p><strong>Please Note:</strong> While we strive to respond to all inquiries promptly, Discover Cook Islands has no obligation to respond within any specific timeframe or at all. Response times may vary depending on the volume of inquiries and the nature of your request. We appreciate your patience and understanding.</p>
        </section>
      </div>
    </div>
  );
}

export default ContactPage;
